




















import { Component, Prop, Mixins } from 'vue-property-decorator';

import { MixinChartGroupEvolution } from '@/plugins/podolib/services/helper/mixins/chart/evolution';

import { TAcquisition } from '@/plugins/podolib/services/entities/EntityPatients';
import { TMode } from '@/plugins/podolib/services/helper/mixins/chart';
//
import ChartEvolutionStancePhaseHeelStrike from '@/components/charts/evolution/ChartEvolutionStancePhaseHeelStrike.vue';
import ChartEvolutionStancePhaseFlatFoot from '@/components/charts/evolution/ChartEvolutionStancePhaseFlatFoot.vue';
import ChartEvolutionStancePhaseHellOff from '@/components/charts/evolution/ChartEvolutionStancePhaseHellOff.vue';
import ChartEvolutionStancePhaseToeOff from '@/components/charts/evolution/ChartEvolutionStancePhaseToeOff.vue';
import ChartEvolutionStancePhaseAttackAngle from '@/components/charts/evolution/ChartEvolutionStancePhaseAttackAngle.vue';

@Component({
  components: {
    ChartEvolutionStancePhaseHeelStrike,
    ChartEvolutionStancePhaseFlatFoot,
    ChartEvolutionStancePhaseHellOff,
    ChartEvolutionStancePhaseToeOff,
    ChartEvolutionStancePhaseAttackAngle,
  },
})
export default class ChartsGroupEvolutionStancePhase extends Mixins(MixinChartGroupEvolution) {}
